if (!customElements.get('product-description')) {
  class ProductDescription extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('details summary');
      this.content = this.querySelector('.product-description__content');
      this.handleClick = this.handleClick.bind(this);

      this.summary.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.summary.removeEventListener('click', this.handleClick)
    }

    handleClick(event) {
      event.preventDefault();
      if (this.details.hasAttribute('open')) {
        this.details.classList.remove('opening');

        this.details.addEventListener('transitionend', () => {
          this.details.removeAttribute('open');
        }, {once: true})
      } else {
        this.details.setAttribute('open', '');
        setTimeout(() => this.details.classList.add('opening'));
      }
    }
  }
  
  customElements.define('product-description', ProductDescription);
}
